import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
// import storage from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';
import userSlice from "./Slices/userSlice.js";
import brokerSlice from "./Slices/brokerSlice.js";
import corporateSlice from "./Slices/corporateSlice.js";
import individualSlice from "./Slices/individualSlice.js";

const rootReducer = combineReducers({
    user: userSlice,
    broker: brokerSlice,
    corporate: corporateSlice,
    individual: individualSlice,
});

const persistConfig = {
    key: 'root',
    storage,
    version: 1,
    whitelist: ["user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);